import { apiClient } from "./scholarships";

/**
 * Client for the institutions' lists and public institutions' bursaries API (the Loans service,
 * openapi/hli-lists-v1.yaml). Same `{ data, etag }` calls and problems as the scholarships client.
 */
export const HLI_LISTS_API = `${process.env.REACT_APP_BASE_URL}hec/hli-lists/`;

export const hliListsApi = apiClient(HLI_LISTS_API);

const BURSARIES = "bursaries";

// Every bursary call, by who makes it
export const bursariesApi = {
  // The student
  mine: () => hliListsApi.get(`${BURSARIES}/me`),
  claim: (body) => hliListsApi.post(`${BURSARIES}/me/claim`, body),
  request: (body) => hliListsApi.post(`${BURSARIES}/me/request`, body),
  correctContact: (body) => hliListsApi.put(`${BURSARIES}/me/contact`, body),
  fileResultClaim: (body) => hliListsApi.post(`${BURSARIES}/me/result-claims`, body),
  myResultClaims: () => hliListsApi.get(`${BURSARIES}/me/result-claims`),

  // The institution's loan officer
  upload: (body) => hliListsApi.post(`${BURSARIES}/uploads`, body),
  myUploads: () => hliListsApi.get(`${BURSARIES}/uploads`),
  window: () => hliListsApi.get(`${BURSARIES}/window`),
  setWindow: (open) => hliListsApi.put(`${BURSARIES}/window`, { open }),
  myStudents: (params) => hliListsApi.get(`${BURSARIES}/students`, { params }),
  myRequests: (params) => hliListsApi.get(`${BURSARIES}/requests`, { params }),
  decideMine: (studentId, body) => hliListsApi.put(`${BURSARIES}/requests/${studentId}/decision`, body),
  mySelections: (academicYearId) => hliListsApi.get(`${BURSARIES}/selections`, { params: { academicYearId } }),
  myGranted: (params) => hliListsApi.get(`${BURSARIES}/granted`, { params }),
  institutionResultClaims: (params) => hliListsApi.get(`${BURSARIES}/result-claims`, { params }),

  // HEC
  allUploads: () => hliListsApi.get(`${BURSARIES}/staff/uploads`),
  institutions: (academicYearId) => hliListsApi.get(`${BURSARIES}/staff/institutions`, { params: { academicYearId } }),
  studentsOf: (institutionId, params) => hliListsApi.get(`${BURSARIES}/staff/institutions/${institutionId}/students`, { params }),
  requestsOf: (institutionId, params) => hliListsApi.get(`${BURSARIES}/staff/institutions/${institutionId}/requests`, { params }),
  setWindowFor: (institutionId, open) => hliListsApi.put(`${BURSARIES}/staff/institutions/${institutionId}/window`, { open }),
  decide: (studentId, body) => hliListsApi.put(`${BURSARIES}/staff/requests/${studentId}/decision`, body),
  link: (studentId, principalId) => hliListsApi.post(`${BURSARIES}/staff/students/${studentId}/link`, { principalId }),
  unlink: (studentId) => hliListsApi.delete(`${BURSARIES}/staff/students/${studentId}/link`),
  selections: (params) => hliListsApi.get(`${BURSARIES}/staff/selections`, { params }),
  setSelection: (body) => hliListsApi.put(`${BURSARIES}/staff/selections`, body),
  runSelection: (selectionId) => hliListsApi.post(`${BURSARIES}/staff/selections/${selectionId}/run`),
  reviewSelection: (selectionId, action) => hliListsApi.post(`${BURSARIES}/staff/selections/${selectionId}/review`, { action }),
  summary: (academicYearId) => hliListsApi.get(`${BURSARIES}/staff/summary`, { params: { academicYearId } }),
  granted: (params) => hliListsApi.get(`${BURSARIES}/staff/granted`, { params }),
  resultClaims: (params) => hliListsApi.get(`${BURSARIES}/staff/result-claims`, { params }),
  setResultClaimStatus: (claimId, status) => hliListsApi.put(`${BURSARIES}/staff/result-claims/${claimId}/status`, { status }),
};

// A private institution's list of students for loans or bursaries, decided as a whole by HEC, the DG and the Minister
export const privateListsApi = {
  // The institution's loan officer
  mine: () => hliListsApi.get("mine"),
  create: (body) => hliListsApi.post("mine", body),
  own: (id) => hliListsApi.get(`mine/${id}`),
  change: (id, body) => hliListsApi.put(`mine/${id}`, body),
  submit: (id) => hliListsApi.post(`mine/${id}/submit`),
  // HEC, the DG and the Minister
  submitted: (state) => hliListsApi.get("staff", { params: state ? { state } : undefined }),
  staffView: (id) => hliListsApi.get(`staff/${id}`),
  decide: (id, body) => hliListsApi.post(`staff/${id}/decision`, body),
  // BRD
  approved: () => hliListsApi.get("brd"),
};
